import React, { useState } from 'react';

import { Clickable, Icon, Layout, Text } from 'ds';
import { formatUsd } from 'helpers';
import { GRAY_50_HEX } from 'shared';
import { selectSalesTaxRate } from 'store/Tenancy/selectors';
import { useAppSelector } from 'store/hooks';

interface MobileOrderSummaryProps {
  itemsSubtotalCents: number;
  disclaimerMessage?: string | JSX.Element;
  showRestockingIncluded?: boolean;
  showItemsSubtotal?: boolean;
  shippingAndAssembly?: JSX.Element;
  orderItems?: JSX.Element;
}

const MobileOrderSummary: React.FC<MobileOrderSummaryProps> = ({
  itemsSubtotalCents,
  disclaimerMessage,
  showRestockingIncluded = false,
  showItemsSubtotal = true,
  shippingAndAssembly,
  orderItems
}) => {
  const [isOpen, setIsOpen] = useState<boolean>(false);
  const salesTaxRate = useAppSelector(selectSalesTaxRate);
  const salesTaxAmountCents =
    salesTaxRate && itemsSubtotalCents ? Math.round((itemsSubtotalCents * salesTaxRate) / 100) : 0;
  const totalCents = itemsSubtotalCents ? itemsSubtotalCents + (salesTaxAmountCents || 0) : 0;
  return (
    <Layout direction="column" color="gray-25" borderBottom={isOpen}>
      <Clickable onClick={() => setIsOpen(!isOpen)}>
        <Layout
          height={56}
          width="100%"
          align="center"
          justify="space-between"
          borderTop
          borderBottom
          paddingX={24}
          color="gray-25"
        >
          <Layout direction="row" gap={8} align="center" justify="center">
            <Text size="body-md">Order summary</Text>

            {isOpen ? (
              <Icon name="upChevron" size="md" color="gray-900" />
            ) : (
              <Icon name="downChevron" size="md" color="gray-900" />
            )}
          </Layout>
          <Text size="body-md" semibold>
            {formatUsd(totalCents / 100)}
          </Text>
        </Layout>
      </Clickable>
      {isOpen && (
        <Layout direction="column" width="100%" paddingX={24} paddingTop={24} paddingBottom={32}>
          {orderItems && orderItems}
          <Layout direction="column" gap={12} paddingBottom={16}>
            {showItemsSubtotal && (
              <Layout justify="space-between" align="center">
                <Text size="body-sm" semibold>
                  Items subtotal
                </Text>
                <Text size="body-sm" semibold>
                  {formatUsd(itemsSubtotalCents / 100)}
                </Text>
              </Layout>
            )}
            {shippingAndAssembly && shippingAndAssembly}
            <Layout justify="space-between" align="center">
              <Text size="body-sm" semibold>
                Tax ({salesTaxRate}%)
              </Text>
              <Text size="body-sm" semibold>
                {formatUsd(salesTaxAmountCents / 100)}
              </Text>
            </Layout>
            {showRestockingIncluded && (
              <Layout justify="space-between" align="center">
                <Text size="body-sm" semibold>
                  Restocking
                </Text>
                <Text size="body-sm" color="purple-gradient" semibold>
                  Included
                </Text>
              </Layout>
            )}
          </Layout>
          <Layout>
            <Layout direction="column" gap={12} paddingTop={16} style={{ borderTop: `2px solid ${GRAY_50_HEX}` }}>
              <Layout direction="row" justify="space-between">
                <Text size="headline-xs" color="gray-900">
                  Total
                </Text>
                <Text size="headline-xs">{formatUsd(totalCents / 100)}</Text>
              </Layout>
              {disclaimerMessage &&
                (React.isValidElement(disclaimerMessage) ? (
                  disclaimerMessage
                ) : (
                  <Text size="body-xs">{disclaimerMessage}</Text>
                ))}
            </Layout>
          </Layout>
        </Layout>
      )}
    </Layout>
  );
};

export default MobileOrderSummary;
